/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import RodoContent from '../../components/RodoContent';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import fetch from '../../core/fetch/fetch.server';
import agentConfig from './agent';
import loadingData from './loading';

import v from './validators';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const OwnerFormDict = {
  OwnerFirstName: {
    label: 'Imię',
    editable: true,
  },
  OwnerLastName: {
    label: 'Nazwisko',
    editable: true,
  },
  OwnerCity: {
    label: 'Miejscowość',
    editable: true,
  },
  OwnerStreet: {
    label: 'Ulica',
    editable: true,
  },
  OwnerNumber: {
    label: 'Numer budynku',
    editable: true,
  },
  OwnerFlat: {
    label: 'Numer lokalu',
    editable: true,
  },
  OwnerZipCode: {
    label: 'Kod pocztowy',
    editable: true,
  },
  OwnerPostOffice: {
    label: 'Poczta',
    editable: true,
  },
};

const InfoDict = {
  parcelAddress: {
    label: 'Adres działki',
    editable: true,
  },
  investDesc: {
    label: 'Planowana inwestycja dotyczy:',
    editable: true,
    type: 'textarea',
  },
};

const InfrastructureDict = {
  investAreaInfo: {
    label: '1. Granice terenu - działki',
    editable: true,
    type: 'textarea',
  },
  investCharacteristics: {
    label: '2. Charakterystyka inwestycji:',
    editable: true,
    type: 'textarea',
  },

  investWater: {
    label: 'a) zaopatrzenie w wodę:',
    editable: true,
    type: 'textarea',
  },
  investEnergy: {
    label: 'b) zaopatrzenie w energię:',
    editable: true,
    type: 'textarea',
  },
  investSewege: {
    label: 'c) sposób odprowadzenia lub oczyszczenia ścieków:',
    editable: true,
    type: 'textarea',
  },
  investOther: {
    label: 'd) inne potrzeby w zakresie infrastruktury technicznej:',
    editable: true,
    type: 'textarea',
  },
  investTrash: {
    label: 'e) sposób unieszkodliwiania odpadów:',
    editable: true,
    type: 'textarea',
  },
};

class DecyzjeWZiULICP extends React.Component {
  state = {
    info: {
      OwnerFirstName: null,
      OwnerLastName: null,
      OwnerCity: null,
      OwnerStreet: null,
      OwnerNumber: null,
      OwnerFlat: null,
      OwnerZipCode: null,
      OwnerPostOffice: null,
      parcelAddress: null,
      investDesc: null,
      investAreaInfo: null,
      investCharacteristics: null,
      investWater: null,
      investEnergy: null,
      investSewege: null,
      investOther: null,
      investTrash: null,
      investLandDevelopType: null,
      investTechCharacteristics: null,
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
    attachments: null,
    loading: false,

  };

  componentWillMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onHide = () => this.setState({ showError: false });


  renderTextArea = (title, field) => (
    <div className="row mobile-row" style={rowStyle}>
      <div className={leftCol} />
      <div className={labelCol}>
        <label style={labelStyle}>{title}</label>
      </div>
      <div className={inputCol}>
        <textarea
          name={field}
          style={{
            width: '100%',
            borderColor:
              Object.keys(this.state.errors).indexOf(field) > -1 &&
                this.state.errors[field] !== null &&
                this.state.errors[field].length > 0
                ? 'red'
                : '#ccc',
          }}
          className="form-control"
          rows={5}
          value={this.state.info[field] ? this.state.info[field] : ''}
          onChange={e => this.onChange(e, 'info')}
        />
        {/* RENDER ERROS IN SPAN */}
        {Object.keys(this.state.errors).indexOf(field) > -1 &&
          this.state.errors[field] !== null &&
          this.state.errors[field].length > 0
          ? this.state.errors[field].map((val, index) => (
            <span key={index} style={errorSpanStyle}>
              {val}
            </span>
          ))
          : null}
      </div>
    </div>
    );

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  nextStep = '/eservices/eserviceSummary/';

  validators = {
    OwnerFirstName: [v.NotNull],
    OwnerLastName: [v.NotNull],
    OwnerCity: [v.NotNull],
    OwnerStreet: [v.NotNull],
    OwnerNumber: [v.NotNull],
    OwnerZipCode: [v.NotNull],
    OwnerPostOffice: [v.NotNull],
    parcelAddress: [v.NotNull],
    investDesc: [v.NotNull],
    investAreaInfo: [v.NotNull],
    investCharacteristics: [v.NotNull],
    investWater: [v.NotNull],
    investEnergy: [v.NotNull],
    investSewege: [v.NotNull],
    investOther: [v.NotNull],
    investTrash: [v.NotNull],
    investLandDevelopType: [v.NotNull],
    investTechCharacteristics: [v.NotNull],
  };

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        OwnerFirstName: 'Jan',
        OwnerLastName: 'Kowalski',
        OwnerCity: 'Warszawa',
        OwnerStreet: 'Testowa',
        OwnerNumber: '10',
        OwnerFlat: '25',
        OwnerZipCode: '01-022',
        OwnerPostOffice: 'Warszawa',
        parcelAddress: 'ul. Testowa 88, 01-022 Warszawa',
        investDesc: 'Inwestycja testowa',
        investAreaInfo: 'granice testowe',
        investCharacteristics: 'charakterystyka testowa',
        investWater: 'woda',
        investEnergy: 'energia',
        investSewege: 'ścieki',
        investOther: 'inne',
        investTrash: 'odpady',
        investLandDevelopType: 'zagospodarowanie testowe',
        investTechCharacteristics: 'parametry testowe',
      },
    });
  };

  validateAttachmentsContent = () => {
    for (const attachment of this.state.attachments) {
      if (attachment.name.length < 1) return true;
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }
    if (!hasFieldErrors) {
      this.props
      .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
        dzialki: this.state.selectedParcels,
        selectedParcels: this.state.selectedParcels,
        info: this.state.info,
        user: {
          ...this.props.serviceInfo.user,
        },
        shortName: this.props.serviceInfo.eservice.shortName,
        urzad: this.props.districts[this.props.prefix],
        attachments: this.state.attachments,
      })
      .then(resp => {
        this.setState({
          loading: false }, () =>
          this.redirectToSummary(resp.jobId));
      });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel
          title={'1. Adres'}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden
            z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li>
                {' '}
                Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer
                działki. W celu dodania kolejnej działki należy powtórzyć czynność.
              </li>
              <li>
                Wskazać działkę w oknie mapy wykorzystując przycisk{' '}
                <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest
                przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.
              </li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku{' '}
            <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ color: 'red' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <DecisionContainer
          title={'2. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoDict}
          onChange={e => this.onChange(e, 'info')}
        />

        <DecisionContainer
          title={'3. Informacje o właścicielu'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={OwnerFormDict}
          onChange={e => this.onChange(e, 'info')}
        />

        <DecisionContainer
          title={'4. Charakterystyka i parametry techniczne oraz infrastruktura'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfrastructureDict}
          onChange={e => this.onChange(e, 'info')}
        >
          {this.renderTextArea('g) określenie planowanego sposobu zagospodarowania terenu, w tym przeznaczenie i gabaryty projektowanych obiektów budowlanych – w formie opisowej i graficznej:', 'investLandDevelopType')}
          {this.renderTextArea('h) charakterystyka parametrów technicznych inwestycji oraz, w przypadku braku obowiązku przeprowadzenia postępowania w sprawie oddziaływania na środowisko, dane charakteryzujące jej wpływ na środowisko', 'investTechCharacteristics')}
        </DecisionContainer>

        {this.props.serviceInfo.eservice.shortName === 'UstalenieULICP' ?
          <GrayPanel title={"Informacja dla wnioskodawcy"}>
            <div className="row">
              <div className="col-sm-12">
                <p><b>Załączniki do wniosku:</b></p>
                <ul>
                  <li>4 egz. aktualnej kopii mapy zasadniczej w skali 1:500 lub 1:1000 a w stosunku do inwestycji liniowych również w skali 1:2000 obejmującej teren którego wniosek dotyczy i obszar na który inwestycja ta będzie oddziaływać (obszar analizowany) - nie mniejszy niż trzykrotna szerokość frontu działki objętej wnioskiem,  nie mniej jednak niż 50 m wokół działki inwestycyjnej</li>
                </ul>
              </div>
            </div>
          </GrayPanel> :
          <GrayPanel title={"Informacja dla wnioskodawcy"}>
            <div className="row">
              <div className="col-sm-12">
                <p><b>Załączniki do wniosku:</b></p>
                <ul>
                  <li>4 egz. aktualnej kopii mapy zasadniczej w skali 1:500 lub 1:1000 obejmującej teren którego wniosek dotyczy i obszar na który inwestycja ta będzie oddziaływać (obszar analizowany) - nie mniejszy niż trzykrotna szerokość frontu działki objętej wnioskiem,  nie mniej jednak niż 50 m wokół działki inwestycyjnej</li>
                </ul>
              </div>
            </div>
          </GrayPanel>
        }

        <RodoContent prefix={this.props.prefix} />

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DecyzjeWZiULICP.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DecyzjeWZiULICP),
);



// WEBPACK FOOTER //
// src/routes/eservices/DecyzjeWZiULICP.js